import angular from 'angular';

class modalContainerDeleteCtrl {
  /* @ngInject */
  constructor(
      ContainerService,
      logger
  ) {
      this.ContainerService = ContainerService;
      this.logger = logger;
  }

  $onInit() {
    this.containersSelected = angular.copy(this.resolve.containersSelected);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  confirm() {
       this.ContainerService.deleteContainers(this.containersSelected).$promise.then(
           () => {
               this.modalInstance.close();
           },
           () => {
               this.modalInstance.close();
               this.logger.error('error.delete');
           }
      );
  }
}

angular.module('app.principal').component('modalContainerDelete', {
  templateUrl: require('./modal-delete-container.html'),
  controller: modalContainerDeleteCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
